import { useTranslation } from 'react-i18next';
import { StyledNumbersCard } from './NumbersCard.styled';
import CircleProgressBar from './CircleProgressBar';

const NumbersCard = ({ img, title, amount, failed, money, score, percentage, waiting }) => {
    const { t } = useTranslation();

    return (
        <StyledNumbersCard>
            {score ? (
                <>
                    <div className='cards-title'>{t('buildings.building_score')}</div>
                    <div className='percentage-bar'>
                        <CircleProgressBar semicircle percentage={percentage} blue />
                        <div className='percentage'>{percentage}%</div>                                          
                    </div>
                </>
            ) : (
                <>
                    <img src={img} />
                    <div className='cards-title'>{title}</div>
                    <div className={`numbers ${failed ? 'failed' : ''} ${money ? 'money' : ''}`}>{amount}</div>  
                    {waiting && <div className='waiting'>{t('buildings.waiting')}</div>}            
                </>
            )}
        </StyledNumbersCard>
    )
}

export default NumbersCard;